<template>
     <el-dialog title="修改代理信息" :visible.sync="modifyCsDialog" width="35%" top="5vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
        <el-card>
            <el-form ref="detailDialog" :model="csForm" label-width="80px">
                <el-form-item label="代理账号">
                    <el-input v-model="csForm.account" :placeholder="this.response.data.phone" disabled></el-input>
                </el-form-item>
                <el-form-item label="代理类型" align="left">
                <el-radio-group v-model="csForm.type" @change="selectType()">
                    <el-radio :label="global.cs_type[1].code" >{{ global.cs_type[1].message }}</el-radio>
                    <el-radio :label="global.cs_type[0].code" >{{ global.cs_type[0].message }}</el-radio>
                </el-radio-group>
                </el-form-item>
                <el-form-item label="主体名称">
                    <el-input v-model="csForm.subjectName" :placeholder="this.response.data.subjectName"></el-input>
                </el-form-item>
                <el-form-item label="联系电话"> <el-input v-model="csForm.phone" :placeholder="this.response.data.phone" clearable></el-input> </el-form-item>
                <el-form-item label="邮箱"><el-input v-model="csForm.email" :placeholder="this.response.data.email" clearable></el-input></el-form-item>
                <el-form-item label="地区">
                    <el-select v-model="csForm.province" clearable :placeholder="this.response.data.provinceStr" @change="provinceChoose" style="width:160px">
                        <el-option v-for="item in this.province" :key="item.code" :label="item.value" :value="item.code" ></el-option>
                    </el-select>
                    <el-select v-model="csForm.city" clearable :placeholder="this.response.data.cityStr" @change="cityChoose" style="width:160px">
                        <el-option v-for="item in this.city" :key="item.code" :label="item.value" :value="item.code"></el-option>
                    </el-select>
                    <el-select v-model="csForm.area" clearable :placeholder="this.response.data.areaStr" style="width:160px" @change="areaChoose">
                        <el-option v-for="item in this.area" :key="item.code" :label="item.value" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="地址"><el-input v-model="csForm.address" :placeholder="this.response.data.address" clearable></el-input></el-form-item>
                <el-form-item label="开通分润" align="left">
                    <el-radio-group v-model="csForm.rewardFlag">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="分润比例" v-if="csForm.rewardFlag == '1'">
                <el-input v-model="csForm.rewardPercent" :disabled="false" :placeholder="this.response.data.rewardPercent" clearable></el-input>
                </el-form-item>
                    <el-form-item label="分润比例" v-else>
                    <el-input v-model="csForm.rewardPercent" :disabled="true" :placeholder="this.response.data.rewardPercent" clearable></el-input>
                </el-form-item>
                <el-form-item label="账号状态">
                    <el-radio-group v-model="csForm.delFlag">
                        <el-radio label="0">正常</el-radio>
                        <el-radio label="1">冻结</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </el-card>
        <span slot="footer" class="dialog-footer">
            <el-button style="background-color:#A9F5F2;margin: 0" @click="modifyCsDialog = false">取消</el-button>
            <el-button style="background-color:#A9F5A9" @click="modifyCs">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {getCsInfoById, updateCs} from "../../api/usermanagement/csList.js";
export default {
    data() {
        return {
            modifyCsDialog: false,
            loading: false,
            csForm: {
                id: "",
                account: "",
                type: "",
                typeStr: "",
                subjectName: "",
                gender: "",
                genderStr: "",
                phone: "",
                email: "",
                province: "",
                provinceStr: "",
                city: "",
                cityStr: "",
                area: "",
                areaStr: "",
                address: "",
                rewardFlag: "",
                rewardPercent: "",
                delFlag: ""
            },
            global: '',
            province: '',
            city: '',
            area: '',
            requestSucceed: false,
            response: {data: []}
        }
    },
    methods: {
        init(id){
            this.modifyCsDialog = true;
            getCsInfoById(id).then(result=>{
                this.csForm.code = result.data.code;
                this.csForm.type = result.data.type;
                this.csForm.gender = result.data.gender;
                this.csForm.rewardFlag = result.data.rewardFlag;
                this.csForm.delFlag = result.data.delFlag;
                this.response.data = result.data;
            })
        },

        /**
         * 代理类型选择
         */
        selectType(value){
            this.csForm.typeStr = value === "0" ? "个人" : "企业";
        },

        /**
         * 修改代理信息
         */
        modifyCs(){
            this.csForm.code = this.response.data.code;
            this.csForm.type = this.csForm.type === '' ? this.response.data.type : this.csForm.type;
            this.csForm.typeStr = this.csForm.typeStr === '' ? this.response.data.typeStr : this.csForm.typeStr;
            this.csForm.subjectName = this.csForm.subjectName === '' ? this.response.data.subjectName : this.csForm.subjectName;
            this.csForm.phone = this.csForm.phone === '' ? this.response.data.phone : this.csForm.phone;
            this.csForm.email = this.csForm.email === '' ? this.response.data.email : this.csForm.email;
            this.csForm.province = this.csForm.province === '' ? this.response.data.province : this.csForm.province;
            this.csForm.provinceStr = this.csForm.provinceStr === '' ? this.response.data.provinceStr : this.csForm.provinceStr;
            this.csForm.city = this.csForm.city === '' ? this.response.data.city : this.csForm.city;
            this.csForm.cityStr = this.csForm.cityStr === '' ? this.response.data.cityStr : this.csForm.cityStr;
            this.csForm.area = this.csForm.area === '' ? this.response.data.area : this.csForm.area;
            this.csForm.areaStr = this.csForm.areaStr === '' ? this.response.data.areaStr : this.csForm.areaStr;
            this.csForm.address = this.csForm.address === '' ? this.response.data.address : this.csForm.address;
            this.csForm.rewardPercent = this.csForm.rewardPercent === '' ? this.response.data.rewardPercent : Number(this.csForm.rewardPercent);
            updateCs(this.csForm).then(result=>{
                this.$emit('modify-succeed','添加成功')
                this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                });
                this.modifyCsDialog = false;
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.csForm.account = "";
            this.csForm.type = "0";
            this.csForm.typeStr = "个人";
            this.csForm.subjectName = "";
            this.csForm.gender = "0";
            this.csForm.genderStr = "男";
            this.csForm.phone = "";
            this.csForm.email = "";
            this.csForm.province = "";
            this.csForm.provinceStr = "";
            this.csForm.city = "";
            this.csForm.cityStr = "";
            this.csForm.area = "";
            this.csForm.areaStr = "";
            this.csForm.address = "";
            this.csForm.rewardFlag = "1";
            this.csForm.rewardPercent = "";
            this.requestSucceed = false;
        },

        /**
        * 省下拉框选择触发事件
        */
        provinceChoose(value){
            this.csForm.city = '';
            this.csForm.area = '';
            for (let item of this.province) {
            if (value == item.code) {
                this.csForm.provinceStr = item.value;
                this.city = item.childrenDictList
            }
            }
        },

        /**
        * 市下拉框选择触发事件
        */
        cityChoose(value){
            this.csForm.area = '';
            for (let item of this.city) {
                if (value == item.code) {
                    this.csForm.cityStr = item.value;
                    this.area = item.childrenDictList;
                }
            }
        },

        /**
        * 区下拉框选择触发事件
        */
        areaChoose(value){
            for (let item of this.area) {
                if (value == item.code) {
                    this.csForm.areaStr = item.value;
                }
            }
        },

    },
    created() {
        this.global = JSON.parse(sessionStorage.getItem("global"));
        this.province = JSON.parse(sessionStorage.getItem("dict")).area;
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/usermanagement/modifyCs.vue